// import { apiEleg } from '../../config/api'
import { getRepresentationModule } from '../../config/apiSinToken'

/**
 * Author: wraudales@ngshn.com
 * Descripcion: Funcion que obtendra las notificaciones que le pertenecen a la ifi por Id
 * Fecha: 3-10-2022
 */
export const getMyNotificationIFI = async (idIFI, idNotificationType) => {
  const data = await getRepresentationModule(
    `api/v1/IFIS/getIFIsNotifications/${idIFI}/${idNotificationType}`,
  )
  return data
}

/**
 * Author: wraudales@ngshn.com
 * Descripcion: Funcion que obtendra el listado de MIPYMES de las cuales son representadas por una IFI
 * Fecha: 3-10-2022
 */
export const getMIPYMESWITHIFIS = async (idUserb2c) => {
  const data = await getRepresentationModule(
    `api/v1/MiPymes/getMiPymesIFIByUser/${idUserb2c}`,
  )
  return data
}

/**
 * Author: wraudales@ngshn.com
 * Descripcion: Funcion que obtendra el listado de MIPYMES de las cuales son representadas por una IFI
 * Fecha: 6-13-2024
 */
export const getMIPYMEWithoutRepresentation = async (idUserb2c) => {
  const data = await getRepresentationModule(
    `api/v1/MiPymes/Unrepresented/GetMipymesByUser?IdUserAzureB2C=${idUserb2c}`,
  )
  return data
}

/**
 * Author: gdegrandez @ngshn.com
 * Descripcion: Funcion que obtendra el listado de MIPYMES para eliminar representacion
 * Fecha: 6-24-2024
 */
export const getActiveMipymes = async (idUserb2c) => {
  const data = await getRepresentationModule(
    `api/v1/MiPymes/GetActiveMipymes?IdUserAzureB2C=${idUserb2c}`,
  )
  return data
}
